import { createBrowserRouter, Navigate } from "react-router-dom";
import { MainMenu } from "../components/MainMenu";
import { Layers, People, PersonAdd } from "@mui/icons-material";
import { ProtectedRoute } from "./ProtectedRoute";
import { Login } from "../pages/Login";
import AddPair from "../pages/addPair/addPair";
import { Register } from "../pages/Register";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Pairs } from "../pages/Pairs";
import { UsersList } from "../pages/UsersList";

const routesWithMenu = [
    { path: "pairs", element: <Pairs />, icon: <Layers />, name: "Pairs" },
    { path: "UsersList", element: <UsersList />, icon: <People />, name: "Users" },
    { path: "create_pair", element: <AddPair />, icon: <PersonAdd />, name: "Add pair" },
    { path: "register", element: <Register />, icon: <PersonAddIcon />, name: "Create user" },
];

export const router = createBrowserRouter([
    { path: "/login", element: <Login /> },
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <MainMenu pages={routesWithMenu}>
                    <Pairs />
                </MainMenu>
            </ProtectedRoute>
        ),
        children: [
            { index: true, element: <Navigate to="/pairs" replace /> },
            ...routesWithMenu.map((route) => ({
                path: route.path,
                element: (
                    <ProtectedRoute>
                        {route.element}
                    </ProtectedRoute>
                ),
            })),
        ],
    },
]);
